import React, { useContext } from "react";
import { ProfileContext } from "../../../contexts/ProfileContext";
import TodoListProfile from "../TodoListProfile";
import { useSelector } from "react-redux";

// Define types for Task and TaskGroup
interface TaskGroup {
  label: string;
  type: number;
  canCreate: boolean;
}

interface Task {
  id: string;
  title: string;
  description?: string;
  dueDate: string;
  taskGroup: TaskGroup;
  person: string;
  finished: boolean;
  label: string;
  tasks: any[];
}

interface ProfileTasksProps {
  tasks: Task[];
  loading: boolean;
  setOwnerModal: (value: any) => void;
  setTodoDetail: (value: any) => void;
  setOpenDetailModal: (value: any) => void;
}

const ProfileTasks: React.FC<ProfileTasksProps> = ({
  tasks,
  loading,
  setOpenDetailModal,
  setOwnerModal,
  setTodoDetail,
}) => {
  const context = useSelector((state: any) => state.user.context);
  const { peopleData } = useContext(ProfileContext);

  return (
    <>
      {loading ? (
        <p>Loading...</p>
      ) : (
        tasks.map((group) => (
          <TodoListProfile
            key={group.id}
            person={peopleData}
            context={context}
            owner="advisor"
            group={group}
            setOwnerModal={setOwnerModal}
            setOpenDetailModal={setOpenDetailModal}
            setTodoDetail={setTodoDetail}
          />
        ))
      )}
      {/* 
      <TodoListProfile
        person={peopleData}
        context={context}
        owner="advisor"
        setOpenAddTodoModal={setOpenAddTodoModal}
        setOwnerModal={setOwnerModal}
        setOpenDetailModal={setOpenDetailModal}
        setTodoDetail={setTodoDetail}
      /> */}
      {/* <TodoListProfile
        setOpenAddTodoModal={setOpenAddTodoModal}
        person={peopleData}
        context={context}
        owner="company"
        setOwnerModal={setOwnerModal}
        setOpenDetailModal={setOpenDetailModal}
        setTodoDetail={setTodoDetail}
      /> */}
    </>
  );
};

export default ProfileTasks;
